module.exports = __webpack_public_path__ + "img/cases-brand-vive-lazyload-31.2af0c2c7.jpg";